module.exports = __webpack_public_path__ + "media/images/category_icons/lesson_plan-a093218e8389feeed33e4a991a2a4806.svg";